

let treeChildren = (index, data, Vue) => {
  var arr = [];
  if (data) {
    for (let i = 1; i < 12; i++) {
      var obj = {};
      let j = ('00' + i).slice(-2);

      obj.title = `${j}`;
      obj.align = 'center';
      // obj.width = '37';
      obj.className = `tree_table_children_${index}`;
      obj.render = (h, row) => {
        var name = `ball${index + 1}`;
        console.log('ballllll', data[row.index])
        const ballData = data[row.index].balls.split(',')
        if (row.row.ball_json[name].nums[j] == 0) {
          return <span class="red">{ballData[index]}</span>;
        } else if (Vue.divideList[j] > row.index) {
          return <span class="divide_lost_info lost_info">{row.row.ball_json[name].nums[j]}</span>;
        } else {
          return <span class="lost_info">{row.row.ball_json[name].nums[j]}</span>;
        }
      };
      arr.push(obj);
    }
    return arr;
  }
};
var lostTreeChildren = (index, data) => {
  var arr = [];
  if (data) {
    for (let i = 1; i < 12; i++) {
      var obj = {};
      let j = ('00' + i).slice(-2);
      obj.title = `${j}`;
      obj.align = 'center';
      // obj.width = '37';
      obj.className = `tree_table_children_${index}`;
      obj.render = (h, row) => {
        var name = `ball${index + 1}`;
        var key = row.row.key;
        var n = row.row.lost.ballJson[name].nums[j];
        if (key != 'averageOmit') {
          return <span>{n[key] ? n[key] : 0}</span>;
        }
      };
      arr.push(obj);
    }
    return arr;
  }
};
let xingtaiChildren = data => {
  var arr = [];
  var shape = ['大', '小', '和', '单', '双', '和'];
  var str = ['big', 'small', 'flat', 'single', 'double', 'flat'];
  if (data) {
    for (let i = 0; i < shape.length; i++) {
      var obj = {};
      obj.title = `${shape[i]}`;
      obj.align = 'center';
      // obj.width = '37';
      obj.className = `join_table_children`;
      obj.render = (h, row) => {
        if (i < 3) {
          // console.log('1data', data[0])
          var divideList = data[0].ballObj.ballBigSmall[str[i]];
          // console.log('1row', row)
          var n = row.row.ballObj.ballBigSmall[str[i]];
          if (n == 0) {
            return <span class={`table_join_${i % 2}`}>{shape[i]}</span>;
          } else if (divideList > row.index) {
            return <span class="divide_lost_info lost_info">{n}</span>;
          } else {
            return <span class="lost_info">{n}</span>;
          }
        } else if (2 < i && i <= 5) {
          var divideList = data[0].ballObj.ballSingleDouble[str[i]];
          var n = row.row.ballObj.ballSingleDouble[str[i]];
          if (row.row.ballObj.ballSingleDouble[str[i]] == 0) {
            return <span class={`table_join_${i % 2}`}>{shape[i]}</span>;
          } else if (divideList > row.index) {
            return <span class="divide_lost_info lost_info">{n}</span>;
          } else {
            return <span class="lost_info">{n}</span>;
          }
        }
      };
      arr.push(obj);
    }
    return arr;
  }
};
var lostXtChildren = (data, index) => {
  var arr = [];
  var shape = ['大', '小', '和', '单', '双', '和'];
  var str = ['big', 'small', 'flat', 'single', 'double', 'flat'];
  if (data) {
    for (let i = 0; i < shape.length; i++) {
      var obj = {};
      obj.title = `${shape[i]}`;
      obj.align = 'center';
      // obj.width = '37';
      obj.className = `join_table_children`;
      obj.render = (h, row) => {
        var name = `ball${index + 1}`;
        var key = row.row.key;
        var n = row.row.lost.ballJson[name];
        if (i < 3) {
          return <span>{n.ballBigSmall[str[i]][key]}</span>;
        } else if (2 < i && i <= 5) {
          return <span>{n.ballSingleDouble[str[i]][key]}</span>;
        }
        // else if (i > 3) {
        //   return <span>{n.ballPrimeCom[str[i]][key]}</span>;
        // }
      };
      arr.push(obj);
    }
    return arr;
  }
};

let lostLuChildren = (data, index) => {
  var arr = [];
  var shape = ['0', '1', '2'];
  var str = ['0', '1', '2'];
  if (data) {
    for (let i = 0; i < shape.length; i++) {
      var obj = {};
      obj.title = `${shape[i]}`;
      obj.align = 'center';
      // obj.width = '37';
      obj.className = `join_table_children`;
      obj.render = (h, row) => {
        var name = `ball${index + 1}`;
        var key = row.row.key;
        var n = row.row.lost.ballJson[name];
        return <span>{n.ballYuShu[str[i]][key] ? n.ballYuShu[str[i]][key] : 0}</span>;
      };
      arr.push(obj);
    }
    return arr;
  }
};

let lostSpjChildren = (data, index) => {
  var arr = [];
  var shape = ['升', '平', '降'];
  var str = ['sheng', 'ping', 'jiang'];
  if (data) {
    for (let i = 0; i < shape.length; i++) {
      var obj = {};
      obj.title = `${shape[i]}`;
      obj.align = 'center';
      // obj.width = '37';
      obj.className = `join_table_children`;
      obj.render = (h, row) => {
        var name = `ball${index + 1}`;
        var key = row.row.key;
        var n = row.row.lost.ballJson[name];
        return <span>{n.ballSPJ[str[i]][key] ? n.ballSPJ[str[i]][key] : 0}</span>;
      };
      arr.push(obj);
    }
    return arr;
  }
};
const choose5 = (data, ballindex) => {
  var ball = ['一', '二', '三', '四', '五'];
  // console.log('aadfahsdfl', data)
  let list = Vue => {
    let arr = [
      {
        title: '期数',
        align: 'center',
        key: 'issue_id',
        className: `table_issueId`,
        width: 170
      },
      {
        title: '开奖号码',
        align: 'center',
        width: 150,
        className: `table_issueId`,
        render: (h, { row }) => {
          let ball = row.balls.split(',')
          return (
            <div class="pk_balls">
              {ball.map((x, i) => {
                return (
                  // <span class={`pk_ball_${i}`} key={i}>
                  <span class={ballindex == i ? 'ball_red' : ''} key={i}>
                    {x}
                  </span>
                );
              })}
            </div>
          );
          // <span class="issue_result">{row.balls.split(',').join('')}</span>;
        }
        // render: (h, { row }) => <span class="issue_result">{row.balls.split(',').join('')}</span>
      },
      {
        // title: '第一球号码走势',
        title: `第${ball[ballindex]}球号码走势`,
        align: 'center',
        // width: 300,
        className: `table_issueId`,
        children: treeChildren(ballindex, data, Vue)
      },
      {
        title: '形态特征',
        align: 'center',
        // width: 300,
        className: `table_issueId`,
        children: xingtaiChildren(data)
      }
      // {
      //   title: '012路',
      //   align: 'center',
      //   className: `table_issueId`,
      //   children: luChildren(data)
      //   // width: 150
      // },
      // {
      //   title: '升平降',
      //   align: 'center',
      //   className: `table_issueId`,
      //   children: spjChildren(data)
      //   // width: 150
      // }
    ];
    return arr;
  };
  let lostList = Vue => {
    let arr = [
      {
        title: '数据统计',
        align: 'center',
        key: 'name',
        className: `table_issueId`,
        width: 320
      },
      {
        // title: '第一球号码走势',
        title: `第${ball[ballindex]}球号码走势`,
        align: 'center',
        // width: 300,
        className: `table_issueId`,
        children: lostTreeChildren(ballindex, data)
      },
      {
        title: '形态特征',
        align: 'center',
        // width: 300,
        className: `table_issueId`,
        children: lostXtChildren(data, ballindex)
      }
      // {
      //   title: '012路',
      //   align: 'center',
      //   className: `table_issueId`,
      //   children: lostLuChildren(data, ballindex)
      //   // width: 150
      // },
      // {
      //   title: '升平降',
      //   align: 'center',
      //   className: `table_issueId`,
      //   children: lostSpjChildren(data, ballindex)
      //   // width: 150
      // }
    ];
    return arr;
  };
  let describe =
    '<p>单 双：自第一球至第五球，开出的号码为双数叫双，如2、8，开出的号码为单数叫单，如5、7，开出11为和。</p>' +
    '<p>大 小：自第一球至第五球，开出的号码 大于或等于6为大，开出的号码小于等于5为小，开出11为和。</p>' +
    '<p>遗漏期数：自上期开出到本期间隔的期数。</p>' +
    '<p>出现次数：统计周期内，某个号码的累计出现次数。</p>' +
    '<p>最大遗漏：是指统计周期内所有遗漏值的最大值。</p>' +
    '<p>最大连出：是指统计周期内所有连出值的最大值。</p>';
  return { list, lostList, describe };
};

export default choose5;



// WEBPACK FOOTER //
// ./src/pages/Trend/Dingweizoushi/columns/choose5.js